import { useParams } from 'react-router-dom';
import Calendar from '../../components/CalendarItem';
import VehicleLayout from '../../components/VehicleLayout';

function VoituresCalendar() {
  const { vehiculeId } = useParams();

  return (
    <VehicleLayout vehicleId={vehiculeId} pageTitle="Calendrier">
      <div>
        <Calendar mois={new Date().getMonth()} vehiculeId={parseInt(vehiculeId)} />
      </div>
    </VehicleLayout>
  );
}

export default VoituresCalendar;
